<template>
  <v-main>
    <loader :loading="loading"></loader>
    <v-container fluid>
      <div class="flex flex-col space-y-6">
        <Header :text="$tc('asset.title', 2)" />
        <div class="p-4 rounded shadow bg-secondary-100">
          <div class="flex flex-row text-lg tracking-wide uppercase text-secondary-700">
            {{ $tc('asset.title', 2) }}
          </div>
          <AssetList @loading="assetsLoading = $event" />
        </div>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import Header from '@/components/helpers/Header';
import Loader from '@/components/helpers/Loader.vue';
import util from '@/mixins/util.js';
import AssetList from '@/modules/asset/views/AssetList';

export default {
  name: 'Dashboard',
  mixins: [util],
  components: {
    Header,
    Loader,
    AssetList,
  },
  data() {
    return {
      assetsLoading: false,
    };
  },
  computed: {
    loading: function() {
      return this.questionnairesLoading;
    },
  },
};
</script>
